
import { Component, ElementRef, Input, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { ItemToSell } from 'src/app/_services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'item-thumbnail',
  templateUrl: './item-thumbnail.component.html',
  styleUrls: ['./item-thumbnail.component.scss']
})
export class ItemThumbnailComponent implements OnInit {
  
  @Input() item: ItemToSell | undefined;
  @Input() showFrame: boolean = true;
  @ViewChild("image") image: ElementRef;
  @Input() square: boolean = false;
  @Input() showPlaceholder: boolean = true;
  @Input() priority: boolean = false;
  @Output() onThumbnailLoaded: EventEmitter<string> = new EventEmitter();
  
  picturesUrl = environment.picturesUrl;
  pictureURL: string | undefined;
  isPortrait: boolean = true;
  aspectRatio: number;
  pictureLoading: boolean = true;
  
  constructor(
      private elementRef: ElementRef) {
  }
  
  ngOnInit(): void {
    
    this.aspectRatio = this.square ? 1/1 : 3/2;

    if (this.item && this.item.pictures.length > 0) {
      this.pictureURL = this.picturesUrl + '/' + this.item.pictures[0].thumbnailKey;  
    }
    
    if (!this.item || this.item!.pictures.length === 0) {
      this.pictureLoading = false;
    }
  }
  
  checkIfPortrait() {
    
    if (this.item!.pictures.length > 0) {
      this.isPortrait = this.image.nativeElement.naturalHeight > this.image.nativeElement.naturalWidth;
    }
    
    console.log('Picture is portrait: ' + this.isPortrait);
    
    this.onThumbnailLoaded.emit();
    this.pictureLoading = false;
  }
  
  fallbackToFull() {
    this.pictureURL = this.picturesUrl + '/' + this.item!.pictures[0].key;
  }
}
